import {message as antdMessage} from "antd";

export const message = {
    success(msg) {
        antdMessage.destroy();
        antdMessage.success(exclamationMark(msg));
    },
    error(msg) {
        antdMessage.destroy();
        antdMessage.error(exclamationMark(msg));
    },
    info(msg) {
        antdMessage.destroy();
        antdMessage.warning(exclamationMark(msg));
    },
    destroy(){
        antdMessage.destroy();
    },
    warn(msg){
        antdMessage.destroy();
        antdMessage.warning(exclamationMark(msg));
    },
    warning(msg){
        antdMessage.destroy();
        antdMessage.warning(exclamationMark(msg));
    },
};

let exclamationMark = (msg) =>{
    if(msg){
        let last = msg.substring(msg.length - 1);
        if(last === '!' || last === '.' || last === '。'){
            return msg.substring(0, msg.length - 1) + "！";
        }else if(last === '！' || last === '?' || last === '？'){
            return msg;
        }else {
            return msg + "！";
        }
    }
    return msg;
};